import React from 'react';
import './ComprarMoto.css';
// 1. Importación de la imagen: Webpack se encarga de la ruta.
import motoImage from '../../images/motosdisponibles.jpg';
import { Link } from 'react-router-dom'; // 2. Importamos el componente Link

export default function ComprarMoto() {
    /*
     * Nota: La función handleMotosClick ya no es necesaria 
     * porque el componente <Link> maneja la navegación directamente.
     */
    const handleMotosClick = () => {
        console.log('Navegando a página de motos (próximamente)');
    };

    return (
        <div className='comprar-moto-section'>
            <div className='comprar-moto-container'>
                <div className='comprar-moto-content'>
                    <div className='comprar-moto-text'>
                        <h2 className='comprar-moto-title'>TU PROXIMA MOTO EN FILONI</h2>
                        <p className='comprar-moto-description'>
                            En FILONI Auto contamos con motos seleccionadas y listas para vos. Encontrá la que más te guste y nosotros nos encargamos del resto.
                        </p>

                        <ul className='comprar-moto-features'>
                            <li>Las mejores motos del mercado</li>
                            <li>Financiación rápida y conveniente.</li>
                            <li>Hacemos del proceso lo más sencillo.</li>
                        </ul>

                        {/* 3. Reemplazamos el <div> por la etiqueta <Link> y le aplicamos la clase de botón */}
                        {/* Usamos className='comprar-moto-btn' para aplicar los estilos de botón directamente al Link */}
                        <Link
                            to="/stock/motos"
                            className='comprar-moto-btn' // Aplicamos la clase que le da estilo de botón
                        >
                            VER MOTOS DISPONIBLES
                            <span className='btn-arrow'>→</span>
                        </Link>

                    </div>

                    <div className='comprar-moto-image'>
                        <img
                            // 4. Usamos la variable importada para que se vea la imagen.
                            src={motoImage}
                            alt="Motos disponibles"
                            className='moto-img'
                        />
                    </div>

                </div>
            </div>
        </div >
    );
}